<template>
    <el-container direction="vertical" class="rating">
        <el-row class="rating-header">
            <el-col :span="24">
                <div class="page-title bold fnt-lg dark text-left">
                    Рейтинг сотрудников
                </div>
            </el-col>
        </el-row>
        <el-row class="rating-tabs">
            <div
                v-for="tab in tabs"
                :key="tab.component"
                :class="['tab-name', { active: activeTab === tab.component }]"
                @click="activeTab = tab.component"
            >
                {{ tab.title }}
            </div>
        </el-row>
        <keep-alive>
            <component :is="activeTab" />
        </keep-alive>
    </el-container>
</template>

<script>
import '@/assets/styles/card.scss';
import '@/assets/styles/card-complex.scss';
import ManagersRating from '@/views/analytics/employers/rating/Managers';
import MeasurersRating from '@/views/analytics/employers/rating/Measurers';
import OfficesRating from '@/views/analytics/employers/rating/Offices';

export default {
    name: 'Rating',
    data() {
        return {
            tabs: [
                { component: 'managers-rating', title: 'по менеджерам' },
                { component: 'measurers-rating', title: 'По замерщикам' },
                { component: 'offices-rating', title: 'По офисам' }
            ]
        };
    },
    components: {
        ManagersRating,
        MeasurersRating,
        OfficesRating
    },
    computed: {
        activeTab: {
            get() {
                return this.$store.state.analytics.lastActiveTab;
            },
            set(value) {
                this.$store.commit('analytics/setLastActiveTab', value);
            }
        }
    }
};
</script>
